import React from "react";

const ProjectQaNdtBookingsIndex = React.lazy(() => import("./index"));
const NewProjectQaNdtBookings = React.lazy(() => import("./new"));
const EditProjectQaNdtBookings = React.lazy(() => import("./edit"));

export default [
  { path: "/project/qa/ndt_bookings/:id/edit", component: EditProjectQaNdtBookings, name: "Edit ProjectQaNdtBooking" },
  { path: "/project/qa/ndt_bookings/new", component: NewProjectQaNdtBookings, name: "New ProjectQaNdtBooking" },
  { path: "/project/qa/ndt_bookings", exact: true, component: ProjectQaNdtBookingsIndex, name: "ProjectQaNdtBookings" },
];
